<template>
    <section id="single-vehicle-stock" :key="vehicle_stock_id">
        <div class="stock-wrapper" v-if="!vehicle_stock_id">
            <div class="container-fluid full-width">
                <div class="row">
                    <div class="col-md-12"> Vehicle not found. </div>
                </div>
            </div>
        </div>
        <div class="stock-wrapper" v-else-if="loading">
            <div class="container-fluid full-width">
                <div class="row">
                    <div class="col-md-12">
<!--                        Loading vehicle data...-->
                    </div>
                </div>
            </div>
        </div>
        <div class="stock-wrapper" v-else>
            <div class="container-fluid full-width">
                <div class="row">
                    <div class="col-md-12">
                        <div id="vehicle-stock-next-prev" v-if="vehicleNextPrevCounterText !== ''">
                            <div class="container-fluid">              
                                <a v-if="currentNextPrev && currentNextPrev.back_to_all" :href="currentNextPrev.back_to_all" class="btn back-to-all-btn">
                                    Back to all
                                </a>
                                <div class="next-prev">
                                    <a class="prev" href="#!" @click.prevent="handleVehicleNextPrev(false)">Prev</a>
                                    <span>{{ vehicleNextPrevCounterText }}</span>
                                    <a class="next" href="#!" @click.prevent="handleVehicleNextPrev(true)">Next</a>
                                </div>
                            </div>
                        </div>
                        <div class="search-result-top">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <h2>Stock - {{ vehicleStockData.year }} {{ vehicleStockData.make }} {{ vehicleStockData.model }}</h2>
                                </div>
                                <div class="col-md-6 col-12 d-flex justify-content-end">
                                    <a v-if="$userCan('delete_stock')" class="link text-danger" href="#!" @click.prevent="deleteVehicleStock">Delete</a>
                                    <a :href="printPath" class="link" target="_blank">Print</a>
                                    <a v-if="$userIsAdmin()" :href="editPath" class="link">Edit</a>                       
                                    <a v-if="currentNextPrev && currentNextPrev.back_to_all" :href="currentNextPrev.back_to_all" class="link">
                                        Back to list
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div id="bid-history" class="col-md-12">
                                <table class="bid-history table table-responsive">
                                    <thead>
                                    <tr>
                                        <th>Day</th>
                                        <th>ID</th>
                                        <th>Make</th>
                                        <th>Model/Grade</th>
                                        <th>Chassis</th>
                                        <th v-if="$userIsAdmin()">CO2 (indication only)</th>
                                        <th>Year</th>
                                        <th>Kms</th>
                                        <th>Colour</th>
                                        <th>CC</th>
                                        <th>Trans</th>
                                        <th>F</th>
                                        <th>Dr</th>
                                        <th>Cnd</th>
                                        <th v-if="$userIsAdmin()">Price</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td class="date">
                                            <template v-if="vehicleStockData.sold_date">
                                                {{ getDate(vehicleStockData.sold_date) }}
                                            </template>
                                        </td>
                                        <td class="id-bid">
                                            <template v-if="vehicleStockData.stock_id">
                                                {{ vehicleStockData.stock_id }}
                                            </template>
                                            <template v-else>
                                                {{ vehicleStockData.green_tree_sync_id }}
                                            </template>
                                        </td>
                                        <td class="make">
                                            {{ vehicleStockData.make }}
                                        </td>
                                        <td class="model">
                                            {{ vehicleStockData.model }} / {{ vehicleStockData.grade }}
                                        </td>
                                        <td>
                                            {{ vehicleStockData.chassis }}
                                        </td>
                                        <td v-if="$userIsAdmin()">
                                            <div v-if="vehicleStockData.co2_text" :class="vehicleStockData.co2_text[0] === '-' ? 'text-danger' : 'text-success'">
                                                {{ vehicleStockData.co2_text.replace('-', '') }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ vehicleStockData.year }}
                                        </td>
                                        <td>
                                            {{ vehicleStockData.mileage }}
                                        </td>
                                        <td class="color">
                                            {{ vehicleStockData.color }}
                                        </td>
                                        <td>
                                            {{ vehicleStockData.engine_capacity }}
                                        </td>
                                        <td>
                                            {{ vehicleStockData.transmission }}
                                        </td>
                                        <td>
                                            {{ vehicleStockData.fuel_type }}
                                        </td>
                                        <td>
                                            {{ vehicleStockData.doors }}
                                        </td>
                                        <td>
                                            {{ vehicleStockData.condition }}
                                        </td>
                                        <td v-if="$userIsAdmin() || vehicleStockData.is_public" class="blue">
                                            <template v-if="!hideStockPrice">
                                                <template v-if="vehicleStockData.user_id === null && vehicleStockData.user_region_price">
                                                    {{vehicleStockData.user_region_price.currency_sign}}
                                                    {{numberWithCommas(vehicleStockData.user_region_price.pivot.price, 9999)}}
                                                    {{vehicleStockData.user_region_price.currency_code}}
                                                </template>
                                                <template v-else-if="vehicleStockData.sold_price">
                                                    <template v-if="vehicleStockData.currency === 'NZD'">$</template>{{ numberWithCommas(vehicleStockData.sold_price, 9999) }}
                                                    {{ vehicleStockData.currency }}
                                                </template>
                                            </template>
                                       </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-md-6 mt-2">
                                        <div v-if="vehicleStockData.buy_now" class="vehicle-banner now-sold">Now Sold</div>
                                        <div v-if="vehicleStockData.estimated_departure_date || vehicleStockData.estimated_arrival_date || vehicleStockData.ship || vehicleStockData.port">
                                            <strong>ETD:</strong> {{getDate(vehicleStockData.estimated_departure_date)}} &nbsp;&nbsp;&nbsp;&nbsp;
                                            <strong>ETA:</strong> {{getDate(vehicleStockData.estimated_arrival_date)}}  &nbsp;&nbsp;&nbsp;&nbsp;
                                            <strong>Ship:</strong> {{vehicleStockData.ship}} &nbsp;&nbsp;&nbsp;&nbsp;
                                            <strong>Port:</strong> {{vehicleStockData.port}}
                                        </div>
                                    </div>
                                    <div class="col-md-6 text-right mt-2" v-if="vehicleStockData.user">
                                        <template v-if="vehicleStockData.company_id === loggedInUser.company_id">
                                            Your stock
                                        </template>
                                        <template v-else>
                                            Stock of
                                            <a :href="$laravelRoute('companies.show', vehicleStockData.company_id)">
                                                {{vehicleStockData.user.name}}
                                                <template v-if="vehicleStockData.company">
                                                    [ {{vehicleStockData.company.name}} ]
                                                </template>
                                            </a>
                                        </template>
                                    </div>
                                </div>
                                <div class="all-bid" v-if="vehicleStockData.messages">
                                    <div v-for="(msg ,index) in vehicleStockData.messages">
                                        <div class="bid history-bid" :class="selectedMessage && selectedMessage.id === msg.id ? 'selected' : ''" @click="selectMessage(msg)">
                                            <div class="cross item">
                                                <button @click="deleteMessage(msg.id, index)"><img src="../../../images/cross.svg" alt="Collapse"></button>
                                            </div>
                                            <div class="date item">
                                                {{ getDate(msg.created_at) }}
                                            </div>
                                            <div class="hour item">
                                                {{ getTime(msg.created_at) }}
                                            </div>
                                            <div class="name item">
                                                {{ msg.user.name }}
                                            </div>
                                            <div class="note item">
                                                <strong v-if="msg.rep_only">staff: </strong>
                                                {{msg.message}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="history-buttons" v-if="!vehicleStockData.is_public">
                                    <a class="link add-message" @click="openMessageModal(false)">
                                        Add Message
                                    </a>
                                    <a class="link staff-message" @click="openMessageModal(true)" v-if="$userIsAdmin()">
                                        Staff Message
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid full-width">
                <div class="row">
                    <div class="col-md-12">
                        <div id="description-vehicle">

                            <div class="description-vehicle">
                                <translatable-text :text="vehicleStockData.description" :translate_now="true"></translatable-text>
                            </div>
                            <div class="equipment" v-if="vehicleStockData.equipment">
                                <strong>Equipment: </strong>{{ vehicleStockData.equipment }}
                            </div>
                            <div class="public_date" v-if="vehicleStockData.is_unsold && vehicleStockData.public_date && $userIsAdmin()">
                                <strong>Will be public on: </strong>{{vehicleStockData.public_date}} ({{daysUntil(vehicleStockData.public_date)}})
                            </div>
                            <div class="notes">
                                <strong>Vehicle Notes: </strong>
                                <span v-html="notes"></span>
                            </div>
                            <div v-if="$userIsAdmin()" class="notes">
                                <strong>Rep Notes: </strong>
                                <span v-html="repNotes"></span>
                            </div>
                            <div v-if="vehicleStockData.api_id && $userIsAdmin()">
                                <a :href="$laravelRoute('vehicle-detail', vehicleStockData.api_id)">
                                    <strong>Auction Purchase</strong>
                                    <span v-if="vehicleStockData.auction_date">{{vehicleStockData.auction_date}}</span>
                                    <span v-if="vehicleStockData.auction_house">{{vehicleStockData.auction_house}}</span>
                                    <span v-if="vehicleStockData.lot">#{{vehicleStockData.lot}}</span>
                                </a>
                            </div>
                            <div id="vehicle-image">
                                <VehicleStockImages :images="vehicleStockData.images" :extra="extraImages"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 d-flex justify-content-center mt-5">
                        <template v-if="showPurchase">
                            <b-button v-b-modal.modal-order class="mr-2">Buy Now</b-button>
                        </template>
                        <template v-if="$userIsAdmin()">
                            <a @click="openSendOfferModal" class="btn mr-2">Send Offer</a>
                        </template>

                        <router-link v-if="vehicleStockData.user_id === loggedInUser.id" :to="`/claims/create?vehicle_id=${vehicle_stock_id}`" class="btn">Make a Claim</router-link>
                    </div>
                </div>

                <!-- <div v-if="vehicleStockData.co2_emissions && $userIsAdmin()">
                    <Co2DataTable :emissions="{data: vehicleStockData.co2_emissions}" @row-click="selectedEmission = $event; showEmissionModal = true" />
                </div> -->
            </div>
            <div class="container-fluid full-width">
                <b-modal id="modal-order" centered size="lg">
                    <template v-slot:modal-header="{ close }">
                        <img src="./../../../images/sbl-logo-blue.png" alt="Sbl Logo" width="250px">
                        <!-- Emulate built in modal header close button action -->
                        <button type="button" aria-label="Close" class="close" @click="close()">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path stroke="#B7B7B7" d="M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z"/></svg>
                        </button>
                    </template>
                    <h5>Confirmation of Vehicle Purchase</h5>
                    <form @submit.stop.prevent>
                        <messages :messages="messages"/>
                        <div class="row">
                            <div class="col-12">
                                By clicking the <strong style="color: #0488DF;">Buy Now</strong> button you are agreeing to purchase the following <br /> <br />
                                <strong v-if="vehicleStockData.stock_id" style="color: #0488DF;">
                                    {{ vehicleStockData.stock_id }},
                                </strong>
                                <strong v-else style="color: #0488DF;">
                                    {{ vehicleStockData.green_tree_sync_id }},
                                </strong>
                                {{ vehicleStockData.year }},
                                {{ vehicleStockData.make }},
                                {{ vehicleStockData.model }} <br />
                                <template v-if="vehicleStockData.user_id === null && vehicleStockData.user_region_price">
                                    <strong style="color: #0488DF;">Price</strong>
                                    <strong style="color: #C69200;">{{vehicleStockData.user_region_price.currency_sign}}{{numberWithCommas(vehicleStockData.user_region_price.pivot.price)}}
                                    {{vehicleStockData.user_region_price.currency_code}}* un-complied + local delivery</strong>
                                </template>
                            </div>
                        </div>
                        <template v-if="vehicleStockData.no_claims_accepted">
                            <div class="row">
                                <div class="col-12">
                                    <br /><br />
                                    You also acknowledge and agree to the following<br /> <br />
                                    <ul>
                                        <li>
                                            You understand that no claims can be made on this vehicle due to the reason outlined below.
                                            <br /><strong style="color: #2F6EBA;">{{ vehicleStockData.no_claims_accepted }}</strong>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </template>
                         <div class="row">
                            <div class="mt-4 acceptance">
                                <b-form-group
                                    v-if="vehicleStockData.no_claims_accepted"
                                    id="input-group-2"
                                    label=""
                                    class="mb-2"
                                    label-for="no_claims_user_confirmed"
                                    :invalid-feedback="invalidField('no_claims_user_confirmed')"
                                >
                                    <b-form-checkbox
                                        id="no_claims_user_confirmed"
                                        v-model="order.no_claims_user_confirmed"
                                        :state="fieldState('no_claims_user_confirmed')"
                                        required
                                    >
                                        I accept full responsibility for the vehicle and release SBL from any liability for current or future issues related to reason above.
                                    </b-form-checkbox>
                                </b-form-group>
                                <b-form-group
                                    id="input-group-2"
                                    label=""
                                    label-for="order_confirm"
                                    :invalid-feedback="invalidField('confirm')"
                                >
                                    <b-form-checkbox
                                        id="order_confirm"
                                        v-model="order.confirm"
                                        :state="fieldState('confirm')"
                                        required
                                    >
                                        I accept the <strong>Buy Now</strong> price and agree to complete<br /> the purchase according to the SBL terms and conditions.
                                    </b-form-checkbox>
                                </b-form-group>
                            </div>  
                        </div>
                    </form>
                    <template v-slot:modal-footer="{ ok, cancel, hide }">
                        <!-- Emulate built in modal footer ok and cancel button actions -->
                        <div class="buttons">
                            <b-button size="sm" variant="danger" @click="cancel()">
                                Cancel
                            </b-button>
                            <b-button type="submit" size="sm" variant="success" @click="sendOrder()">
                                Buy Now
                            </b-button>
                        </div>
                        <small class="mt-3">
                            *Please Note: This price does not include the $225 BMSB Heat Treatment surcharge.
                            MPI has determined that the BMSB season runs from September 1st until April 30th,
                            however this is subject to change at any time by MPI.
                            Should Heat Treatment be required for this vehicle, the related BMSB Heat Treatment
                            charge will be applied at the time of final invoice.
                        </small>
                    </template>
                </b-modal>
            </div>
            <VehicleStockMessage ref="message" @changed="onAddMessage"></VehicleStockMessage>
            <vehicle-send-offer-modal :vehicle="vehicleStockData" :vehicle_id="vehicleStockData.id" v-model="sendOfferModalOpen"></vehicle-send-offer-modal>

            <EmissionModal 
                :show="showEmissionModal" 
                :emission="selectedEmission" 
                @close="showEmissionModal = false"
            />
        </div>
    </section>
</template>
<script>
import {objLookup, nl2br, numberWithCommas, objToUrl} from '../../util/common'
    import BootstrapValidation from '../../mixins/bootstrap-validation';
    import VehicleStockImages from '../Common/VehicleStockImages'
    import VehicleStockMessage from './VehicleStockMessage'
    import Inspection from './Inspection'
    import VehicleSendOfferModal from "../VehicleSendOfferModal";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import EmissionModal from './../Co2Emissions/EmissionModal.vue'
import Co2DataTable from './../Co2Emissions/DataTable.vue'
    export default {
        props: [
            'vehicle_stock_id',
        ],
        components: {VehicleSendOfferModal, VehicleStockImages, VehicleStockMessage, Inspection, EmissionModal, Co2DataTable},
        async created(){
            if (this.userHasPrivilege('stop_credit')) {
                let rep = objLookup(this.loggedInUser, 'sales_rep.first_name');
                if (rep) {
                    rep = ' - ' + rep
                }
                this.messages.push({type: 'danger', message: 'Your purchased cannot be processed at this time please contact your sales representative' + rep})
            }
            if (this.vehicle_stock_id) {
                this.getVehicleData()
            }
            window.addEventListener('keyup', this.handleNextPrevKeypress)

            if (this.$route.query.state_key) {
                await this.checkStack(this.$route.query.state_key)
            }
            setTimeout(async () => {
                this.vehicleNextPrevCounter()
                await this.checkForCachedData();
                document.title = `Vehicle stock - ${this.vehicleStockData.make} ${this.vehicleStockData.model}`
            }, 50)
        },
        mixins: [BootstrapValidation],
        data() {
            const address_suburb = this.loggedInUser.profile.address ? this.loggedInUser.profile.address.split('\n') : '';
            let address = this.loggedInUser.profile.address || '';
            let suburb = this.loggedInUser.profile.suburb || '';
            if (!suburb && address_suburb.length > 1) {
                suburb = address_suburb[ address_suburb.length -1 ];
                address = address_suburb[ 0 ];
            }
            return {
                sendOfferModalOpen: false,
                loading: true,
                showEmissionModal: false,
                vehicleStockData: null,
                hideStockPrice: this.userHasPrivilege('hide_stock_prices'),
                vehicleNextPrevCounterText: '',
                images: [],
                imagesType: ['sheet', 'front', 'back', 'interior'],
                titles: [{text: 'Mr.', value: 'Mr.'}, {text: 'Mrs.', value: 'Mrs.'},],
                order: {
                    'title': 'Mr.',
                    'first_name': this.loggedInUser.first_name,
                    'last_name': this.loggedInUser.last_name,
                    'company': this.loggedInUser.company ? this.loggedInUser.company.name : '',
                    'address': address,
                    'city': this.loggedInUser.profile.city || '',
                    'suburb': suburb,
                    'postal_code': this.loggedInUser.profile.postal_code || '',
                    'country': this.loggedInUser.profile.country || '',
                    'phone': this.loggedInUser.profile.phone || '',
                    'fax': this.loggedInUser.profile.fax || '',
                    'email': this.loggedInUser.email,
                    'no_claims_user_confirmed': false,
                    'destination_port': '',
                    'comment': '',
                },
                messages: [],
                selectedMessage: null,
                errors: [],
                editPath: this.$laravelRoute('vehicle-stock.edit', this.vehicle_stock_id),
                printPath: this.$laravelRoute('vehicle-stock.print', this.vehicle_stock_id),
                allVehicleStocksPath: this.$laravelRoute('vehicle-stock.index'),
            }
        },
        computed: {
            ...mapState({
                single_vehicle: state => state.vehicleStock.single_vehicle,
                single_next: state => state.vehicleStock.single_next,
                single_prev: state => state.vehicleStock.single_prev,
            }),
            ...mapGetters({
                currentNextPrev: 'stock_nextprev/current',
            }),
            extraImages(){
                if (this.vehicleStockData.extra_images && this.vehicleStockData.extra_images.length){
                    let images = []
                    this.vehicleStockData.extra_images.forEach(img => {
                        if (img.active) {
                            images.push({
                                large: img.url,
                                medium: img.url,
                                thumbnail: img.url,
                            })
                        }
                    })
                    return images
                }
                return null
            },
            notes(){
                if (this.vehicleStockData && this.vehicleStockData.auction_note) {
                    return nl2br(this.vehicleStockData.auction_note)
                }
                return ''
            },
            repNotes(){
                if (this.vehicleStockData && this.vehicleStockData.rep_note) {
                    return nl2br(this.vehicleStockData.rep_note)
                }
                return ''
            },
            equipmentString(){
                if (this.vehicleStockData
                    && this.vehicleStockData.equipment_items
                    && this.vehicleStockData.equipment_items.length) {
                    return this.vehicleStockData.equipment_items
                        .map(item => item.label).join(', ')
                }
                return ''
            },
            showPurchase(){
                if (this.vehicleStockData.buy_now) {
                    return false
                }

                // if a vehicle has a user assigned, then it shouldn't be shown. Unless it's unsold
                if (this.vehicleStockData.user && !this.vehicleStockData.is_unsold) {
                    return false; // if a vehicle has a user assigned, then it shouldn't be shown.
                }

                if (this.vehicleStockData && this.vehicleStockData.stock_requests && this.vehicleStockData.stock_requests.length) {
                    return false
                }
                return true
            }
        },
        beforeDestroy() {
            window.removeEventListener('keyup', this.handleNextPrevKeypress)
        },
        methods: {
            ...mapMutations({
                setSingleNext: 'vehicleStock/setSingleNext',
                setSinglePrev: 'vehicleStock/setSinglePrev',
                setSingleVehicle: 'vehicleStock/setSingleVehicle',
            }),
            ...mapActions({
                checkStack: 'stock_nextprev/checkStack',
            }),
            numberWithCommas,
            objLookup(obj, key) {
                return objLookup(obj, key);
            },
            daysUntil(date){
                if (date) {
                    const now = window.moment()
                    const days = window.moment(date).diff(now, 'days') + 1
                    if (days === 1) {
                        return days + ' day'
                    }
                    return days + ' days';
                }
                return ''
            },
            openSendOfferModal(){
                const extraSend = this.vehicleStockData.extra_images.filter(img => img.offer_send)
                const hasOfferImages = extraSend.length || this.vehicleStockData.front_image_offer_send
                    || this.vehicleStockData.sheet_image_offer_send
                    || this.vehicleStockData.inside_image_offer_send
                    || this.vehicleStockData.back_image_offer_send;
                if (!hasOfferImages) {
                    this.$bvModal
                        .msgBoxConfirm('There are no stock offer images setup, are you sure you want to send an offer?')
                        .then(() => {
                            this.sendOfferModalOpen = true
                        })
                } else {
                    this.sendOfferModalOpen = true
                }
            },
            deleteVehicleStock () {
                this.$bvModal
                    .msgBoxConfirm('Are you sure you want to delete this vehicle?')
                    .then(value => {
                        this.$store.dispatch('vehicleStock/deleteVehicleStock', {
                            id: this.vehicleStockData.id,
                        }).then(vehicle_stocks => {

                        });
                    })
            },
            async getVehicleData(){
                this.loading = true
                try {
                    let data = await this.requestVehicleData(this.vehicle_stock_id)
                    if (data) {
                        this.setSingleVehicle(data);
                        this.vehicleStockData = data;
                    }
                    this.loading = false
                } catch (e) {
                    console.warn(e);
                    this.loading = false;
                }
            },
            async handleVehicleNextPrev(next) {
                const processUrl = url => {
                    if (this.$route.query.state_key) {
                        if (url.indexOf('?') === -1) {
                            url = url + '?state_key=' + this.$route.query.state_key
                        } else {
                            url = url + '&state_key=' + this.$route.query.state_key
                        }
                    }
                    return url
                }
                if (next) {
                    if (this.single_next && this.single_next.id === this.next_id()) {
                        let url = processUrl(this.$laravelRoute('vehicle-stock.show', this.single_next.id, false));
                        this.setSinglePrev(this.vehicleStockData)
                        this.setSingleVehicle(this.single_next);
                        await this.$router.push(url);
                    }
                } else {
                    if (this.single_prev && this.single_prev.id === this.prev_id()) {
                        let url = processUrl(this.$laravelRoute('vehicle-stock.show', this.single_prev.id, false));
                        this.setSingleNext(this.vehicleStockData)
                        this.setSingleVehicle(this.single_prev);
                        await this.$router.push(url);
                    }
                }
            },
            getNextPrevId(next = true) {
                let matches = window.location.pathname.match(/\/vehicle-stock\/(\d{1,})/);
                let id = null;
                if (matches && matches.length === 2 && this.currentNextPrev) {
                    let current = parseInt(matches[1]);
                    let i = this.currentNextPrev.ids.indexOf(current);
                    if (i !== -1) {
                        if (next) {
                            if ((i+1) === this.currentNextPrev.ids.length) {
                                id = this.currentNextPrev.ids[0];
                            } else {
                                id = this.currentNextPrev.ids[i+1];
                            }
                        } else {
                            if ((i-1) === -1) {
                                id = this.currentNextPrev.ids[this.currentNextPrev.ids.length - 1];
                            } else {
                                id = this.currentNextPrev.ids[i-1];
                            }
                        }
                    }
                }
                return id;
            },
            next_id(){
                return this.getNextPrevId(true)
            },
            prev_id(){
                return this.getNextPrevId(false)
            },
            async checkForCachedData() {
                if (this.single_vehicle && this.single_vehicle.id === parseInt(this.vehicle_stock_id)) {
                    this.vehicleStockData = this.single_vehicle
                    this.loading = false
                }
                if (this.next_id()) {
                    if (!(this.single_next && this.single_next.id) || (this.single_next && this.single_next.id !== this.next_id())) {
                        let next_data = await this.requestVehicleData(this.next_id())
                        if (next_data) {
                            this.setSingleNext(next_data)
                        }
                    }
                }
                if (this.prev_id()) {
                    if (!(this.single_prev && this.single_prev.id) || (this.single_prev && this.single_prev.id !== this.prev_id())) {
                        let prev_data = await this.requestVehicleData(this.prev_id())
                        if (prev_data) {
                            this.setSinglePrev(prev_data)
                        }
                    }
                }
            },
            handleNextPrevKeypress(e) {
                if (e.keyCode) {
                    const isLeftRight = e.keyCode === 37 //left
                        || e.keyCode === 39 //right
                    if (isLeftRight) {
                        this.handleVehicleNextPrev(e.keyCode === 39);
                    }
                }
            },
            async requestVehicleData(vid) {
                let data;
                let url = this.$laravelRoute('vehicle-stock.show', vid, false);
                let args = {}
                if (this.$route.query) {
                    args = Object.assign(args, this.$route.query)
                }
                url += '?' + objToUrl(args);
                try {
                    let result = await this.axios.get(url);
                    console.log('request data', result)
                    if (result && result.data && result.data.vehicle_stock) {
                        data = result.data.vehicle_stock;
                    }
                } catch (e) {
                    console.warn(e);
                }
                return data;
            },

            vehicleNextPrevCounter(){
                let found = false;
                if (this.currentNextPrev) {
                    let matches = window.location.pathname.match(/\/vehicle-stock\/(\d{1,})/);
                    if (matches && matches.length === 2 && this.currentNextPrev) {
                        let current = parseInt(matches[1]);
                        let i = this.currentNextPrev.ids.indexOf(current);
                        if (i !== -1) {
                            let total = this.currentNextPrev.ids.length;
                            this.vehicleNextPrevCounterText = `${i + 1} of ${total}`
                            found = true
                        }
                    }
                }
                if (!found) {
                    this.vehicleNextPrevCounterText = '';
                }
            },
            deleteMessage(message_id){
                this.$bvModal
                    .msgBoxConfirm('Are you sure you want to delete this message?')
                    .then(value => {
                        if (value) {
                            this.messages = [];
                            this.$store.dispatch('vehicleStock/deleteVehicleStockMessage', {message_id}).then(response => {
                                if (response) {
                                    let index = null;
                                    this.vehicleStockData.messages.forEach((msg, i) => {
                                        if (msg.id === message_id) {
                                            index = i
                                        }
                                    })
                                    if (index !== null) {
                                        this.vehicleStockData.messages.splice(index, 1);
                                    }
                                } else {
                                    this.messages.push({type: 'danger', message: 'Could not delete message'});
                                }
                            }).catch(error => {
                                this.messages.push({type: 'danger', message: error.message});
                                this.errors = error.errors;
                            });
                        }
                    })
            },
            getDate(data) {
                return window.moment(data).format(this.defaultMomentDateFormat())
            },
            getTime(data) {
                return window.moment(data).format('HH:mm')
            },
            openMessageModal(repOnly){
                let msg = ''
                if (this.selectedMessage) {
                    msg = `Hi ${this.selectedMessage.user.first_name},  \n${this.selectedMessage.message}`
                }
                this.$refs.message.openModal(this.vehicleStockData, repOnly, msg)
            },
            sendOrder() {
                if (this.order.confirm) {
                    this.messages = [];
                    this.$store.dispatch('vehicleStock/buyNowRequest', {
                        order: this.order,
                        vehicle_stock_id: this.vehicleStockData.id
                    }).then(response => {
                        if (response) {
                            this.clearOrder();
                            this.$bvModal.hide('modal-order');
                            this.errors = [];
                            this.$message({
                                message: 'Thanks for your purchase our team will be in contact shortly',
                                type: 'success'
                            });
                        } else {
                            this.messages.push({type: 'danger', message: 'Unable to send order'});
                        }
                    }).catch(error => {
                        this.messages.push({type: 'danger', message: error.message});
                        this.errors = error.errors;
                    });
                } else {
                    this.messages.push({type: 'danger', message: 'Please tick the confirmation checkbox'});
                }
            },
            selectMessage(msg) {
                if (this.selectedMessage && this.selectedMessage.id === msg.id) {
                    this.selectedMessage = null
                } else {
                    this.selectedMessage = msg
                }
            },
            onAddMessage(id, msg){
                this.vehicleStockData.messages.push(msg)
            },
            clearOrder() {
                this.order = {
                    'title': 'Mr.',
                    'first_name': '',
                    'last_name': '',
                    'company': '',
                    'address': '',
                    'city': '',
                    'suburb': '',
                    'postal_code': '',
                    'country': '',
                    'phone': '',
                    'fax': '',
                    'email': '',
                    'destination_port': '',
                    'comment': '',
                };
            },
        }
    }
</script>
<style scoped lang="scss">
#modal-order{
    .custom-checkbox{
        padding-left: 5px;
    }
}
.back-to-all-btn{
    position: absolute;
    left: 0;
    top: 25px;
}
</style>





// WEBPACK FOOTER //
// resources/js/components/VehicleStock/ShowPage.vue